export default __webpack_public_path__ + "static/media/Tile_Game_Connect.0e7e68b3.mp3";